import {FormControl} from "@angular/forms";

export class SiteModel{
  private _clientID: string | null;
  private _clientName: String;
  private _siteID: string | null;
  private _siteName: String;
  private _address: String;
  private _city: String;
  private _state: String;
  private _zipcode: String;
  private _phone: Number;
  private _ipAddress: FormControl<string | null>;
  private _sqft: Number;
  private _lat: Number;
  private _long: Number

  constructor(clientID?: string, siteID?: string);
  constructor(clientID: string, siteID: string) {
    this.clientID = clientID;
    this.siteID = siteID;
    this.clientName = "Test";
    this.siteName = "Test Site";
  }

  get clientID() {
    return this._clientID;
  }

  set clientID(val) {
    this._clientID = val;
  }

  get clientName() {
    return this._clientName;
  }

  set clientName(val) {
    this._clientName = val;
  }
  get siteID() {
    return this._siteID;
  }

  set siteID(val) {
    this._siteID = val;
  }
  get siteName() {
    return this._siteName;
  }

  set siteName(val) {
    this._siteName = val;
  }
  get address() {
    return this._address;
  }

  set address(val) {
    this._address = val;
  }
  get city() {
    return this._city;
  }

  set city(val) {
    this._city = val;
  }
  get state() {
    return this._state;
  }

  set state(val) {
    this._state = val;
  }
  get zipcode() {
    return this._zipcode;
  }

  set zipcode(val) {
    this._zipcode = val;
  }
  get phone() {
    return this._phone;
  }

  set phone(val) {
    this._phone = val;
  }
  get ipAddress() {
    return this._ipAddress;
  }

  set ipAddress(val) {
    this._ipAddress = val;
  }
  get sqft() {
    return this._sqft;
  }

  set sqft(val) {
    this._sqft = val;
  }

  get lat() {
    return this._lat;
  }

  set lat(val) {
    this._lat = val;
  }

  get long() {
    return this._long;
  }

  set long(val) {
    this._long = val;
  }
}
